var _rect, _path, _circle, _circle2, _path2, _rect2, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 128,
    viewBox: "0 0 160 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Editing a communication template") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 18,
    width: 111,
    height: 92,
    rx: 8,
    fill: "#D7E0EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 18h95a8 8 0 0 1 8 8v12H22V26a8 8 0 0 1 8-8Z",
    fill: "#45556D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 28,
    r: 2.5,
    fill: "#B69782"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 28,
    r: 2.5,
    fill: "#B69782"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 54h35M36 67h24M36 91h50",
    stroke: "#A6B2C2",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 49,
    width: 37,
    height: 27,
    rx: 3,
    fill: "#E8EDF3",
    stroke: "#596475",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#596475"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 46,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 73,
    width: 6,
    height: 6,
    rx: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(35 122 91)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 64,
    width: 11,
    height: 44,
    rx: 3,
    fill: "#B69782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117 107 5.5 11 5.5-11",
    fill: "#45556D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 72h9",
    stroke: "#FFF1E8",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureControl);
export default __webpack_public_path__ + "static/media/feature-control.bf3db6fef82ad615da9ab756fb92c6cc.svg";
export { ForwardRef as ReactComponent };